module.exports = __webpack_public_path__ + "img/tabbed-search-filter-lincoln.9c92fffb.png";